export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const LEDGER_DEFAULT_PAGE_SIZE = 100;
